import React, { useEffect, useRef } from "react";
import "./MonyxxStats.css";
import { Sparkles } from "lucide-react";

export const MonyxxStats = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    let width, height;
    let time = 0;

    const resize = () => {
      width = canvas.width = window.innerWidth;
      height = canvas.height = 500;
    };
    window.addEventListener("resize", resize);
    resize();

    const draw = () => {
      ctx.clearRect(0, 0, width, height);
      time += 0.005;

      // Movimento de câmera/rotação simulada
      const spin = time * 0.5;

      ctx.save();
      ctx.translate(width / 2, height / 2);

      // Quantidade de linhas que formam a "fita" (ribbon)
      const lines = 45;

      for (let i = 0; i < lines; i++) {
        ctx.beginPath();
        
        // Variação de cor gradiente: Verde Esmeralda (150) ao Azul (210)
        const hue = 150 + (i / lines) * 60 + Math.sin(time) * 20;
        ctx.strokeStyle = `hsla(${hue}, 80%, 60%, ${0.1 + (i / lines) * 0.2})`;
        ctx.lineWidth = 1.5;

        for (let x = -width / 2; x <= width / 2; x += 10) {
          // Fórmula matemática para criar o fluxo da fita 3D girando
          const xNorm = x / (width / 2);
          const offset = i * 0.1;
          
          const y1 = Math.sin(xNorm * 3 + time + offset) * 50;
          const y2 = Math.cos(xNorm * 2 - time * 0.8 + offset) * 40;
          const rotateZ = Math.sin(time * 0.2 + xNorm) * 0.5;
          
          // Efeito 3D simulado de girar
          const perspectiveY = y1 * Math.cos(spin) - y2 * Math.sin(spin);
          const finalY = perspectiveY + Math.sin(xNorm * Math.PI) * 100 * (i / lines);

          if (x === -width / 2) {
            ctx.moveTo(x, finalY);
          } else {
            ctx.lineTo(x, finalY);
          }
        }
        ctx.stroke();
      }
      ctx.restore();

      requestAnimationFrame(draw);
    };

    const animId = requestAnimationFrame(draw);
    return () => {
      window.removeEventListener("resize", resize);
      cancelAnimationFrame(animId);
    };
  }, []);

  return (
    <section className="monyxx-stats-section py-20 md:py-32 relative overflow-hidden">
      
      {/* Glows de fundo para dar a iluminação estilo Monyxx */}
      <div className="wave-container">
        <div className="glow-orb green-orb"></div>
        <div className="glow-orb blue-orb"></div>
        
        {/* Canvas Giratório de alta performance */}
        <canvas ref={canvasRef} className="stripe-canvas" />
      </div>

      <div className="max-w-7xl mx-auto px-5 md:px-8 relative z-10">
        
        {/* Top Text */}
        <div className="max-w-4xl mx-auto text-center flex flex-col items-center">
          <span className="pill mb-6" data-testid="stats-pill" style={{ boxShadow: '0 4px 14px rgba(0,0,0,0.5)' }}>
            <Sparkles className="h-3.5 w-3.5" /> Nova era da gestão financeira pessoal
          </span>
          <h2 className="text-4xl md:text-[44px] font-display font-medium leading-tight text-white">
            <strong className="font-bold">Controle suas finanças na <span className="text-emerald-400">velocidade do pensamento.</span></strong> Mande um <span className="text-blue-400 font-semibold">áudio</span> no próprio painel e veja tudo ser atualizado <span className="text-emerald-400 font-semibold">instantaneamente</span>, com organização impecável.
          </h2>
        </div>

        {/* Bottom Stats */}
        <div className="mt-32 grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-6 border-t border-slate-800/60 pt-10">
          
          <div className="stat-block">
            <h3 className="text-4xl md:text-5xl font-display font-bold stat-gradient mb-2">Mais de 10 mil</h3>
            <p className="text-slate-300 text-sm md:text-base font-medium">Lançamentos processados pela IA</p>
          </div>

          <div className="stat-block">
            <h3 className="text-4xl md:text-5xl font-display font-bold stat-gradient mb-2">Menos de 3s</h3>
            <p className="text-slate-300 text-sm md:text-base font-medium">Tempo médio de resposta da IA</p>
          </div>

          <div className="stat-block">
            <h3 className="text-4xl md:text-5xl font-display font-bold stat-gradient mb-2">100% Seguro</h3>
            <p className="text-slate-300 text-sm md:text-base font-medium">Criptografia de ponta a ponta</p>
          </div>

        </div>

      </div>
    </section>
  );
};
